import { AutoAwesomeRounded, EditCalendarRounded, InsightsRounded } from '@mui/icons-material';
import GoalStepLayout, { type GoalOption } from './GoalStepLayout';
import type { OnboardingGoal } from './onboarding-goals';

interface AndieGoalStepProps {
    value: OnboardingGoal | '';
    onSelect: (goal: OnboardingGoal) => void;
}

const OPTIONS: GoalOption[] = [
    { value: 'create', icon: EditCalendarRounded },
    { value: 'analyze', icon: InsightsRounded },
    { value: 'unsure', icon: AutoAwesomeRounded },
];

/**
 * The goal step for a user who arrives with a profile connected.
 *
 * Andie takes it from here, so the copy says so and the iconography is the AI sparkle. Only
 * reachable with a profile: without one Andie has no branding, no analytics and nowhere to save a
 * post, which is what the guided step exists for.
 */
const AndieGoalStep = ({ value, onSelect }: AndieGoalStepProps) => (
    <GoalStepLayout
        value={value}
        onSelect={onSelect}
        keyPrefix="onboarding.in-app.goal"
        headerIcon={AutoAwesomeRounded}
        options={OPTIONS}
    />
);

export default AndieGoalStep;
